import React from 'react';
import { WebsiteDesignProps } from './types';
import { Gamepad2, Mouse, Cpu } from 'lucide-react';
import { Button } from "@/components/ui/button";

const PixelWorld: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "8-Bit Academy";

    return (
        <div className="bg-[#2c2c2c] min-h-screen font-mono text-white image-pixelated">
            <style>{`
                @font-face {
                    font-family: 'PixelFont';
                    src: url('https://fonts.cdnfonts.com/s/11559/PressStart2P-Regular.woff') format('woff');
                }
                .font-pixel { font-family: 'Courier New', monospace; letter-spacing: -1px; }
            `}</style>

            <nav className="bg-[#4a4a4a] border-b-4 border-black p-4 flex justify-between items-center">
                <div className="text-2xl text-green-400 font-bold uppercase tracking-widest shadow-black drop-shadow-md">
                    {schoolName}
                </div>
                <div className="flex gap-4">
                    <Button className="bg-blue-500 hover:bg-blue-600 text-white border-b-4 border-blue-700 active:border-b-0 active:mt-1 rounded-none font-bold uppercase">
                        Start
                    </Button>
                </div>
            </nav>

            <main className="container mx-auto px-4 py-12 text-center">
                <div className="inline-block bg-black p-8 border-4 border-white mb-12 relative shadow-[8px_8px_0_gray]">
                     <div className="absolute top-0 left-0 w-2 h-2 bg-white"></div>
                     <div className="absolute top-0 right-0 w-2 h-2 bg-white"></div>
                     <div className="absolute bottom-0 left-0 w-2 h-2 bg-white"></div>
                     <div className="absolute bottom-0 right-0 w-2 h-2 bg-white"></div>
                     
                     <h1 className="text-4xl md:text-6xl mb-6 text-yellow-400 font-bold uppercase leading-relaxed">
                         Level Up Your <br/> Knowledge
                     </h1>
                     <p className="text-gray-300 text-sm md:text-base leading-loose max-w-lg mx-auto">
                         INSERT COIN TO BEGIN LEARNING SEQUENCE. <br/>
                         LOADING WORLD... 99%
                     </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
                    {[
                        { icon: Gamepad2, color: "text-red-400", title: "Skill Tree" },
                        { icon: Cpu, color: "text-green-400", title: "Logic Gates" },
                        { icon: Mouse, color: "text-blue-400", title: "Input/Output" },
                    ].map((item, i) => (
                        <div key={i} className="bg-[#3a3a3a] p-6 border-4 border-black hover:bg-[#4a4a4a] cursor-pointer transition-colors group">
                            <item.icon className={`mx-auto mb-4 ${item.color} w-12 h-12 group-hover:scale-110 transition-transform`} />
                            <h3 className="text-xl font-bold uppercase mb-2">{item.title}</h3>
                            <div className="h-2 w-full bg-black rounded-full overflow-hidden">
                                <div className="h-full bg-green-500 w-2/3"></div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-16">
                    <img src="https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=2070&auto=format&fit=crop" className="mx-auto border-4 border-white w-full max-w-2xl image-pixelated grayscale contrast-125 hover:grayscale-0 transition-all" style={{imageRendering: 'pixelated'}} alt="Pixel Art" />
                </div>
            </main>
        </div>
    );
};

export default PixelWorld;
